import React from "react";

interface IconProps {
    active?: boolean;
    size?: number;
}

/** Sidebar section icon — stroke style shared with the mobile tab bar. */
const IconConfiguration: React.FC<IconProps> = ({ active = false, size = 24 }) => {
    const color = active ? "#0F7679" : "#6A7878";
    return (
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 6h14M3 10h14M3 14h14"/><circle cx="7" cy="6" r="1.8" fill="#fff"/><circle cx="13" cy="10" r="1.8" fill="#fff"/><circle cx="8.5" cy="14" r="1.8" fill="#fff"/>
        </svg>
    );
};

export default IconConfiguration;
